import React from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./Header";
import Drawer from "./Drawer";
import { Box } from "@mui/material";
import SC from "./style";
import FolderDrawerLayout from "./FolderDrawerLayout";
import InnoIcons from "@InnoIcons/";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

const drawerWidth = 240;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  boxShadow: "none !important",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Layout(props) {
  const {
    children,
    showdrawer = false,
    drawerItems = [],
    drawerVariant = "default",
  } = props;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const accessControlData = useSelector(
    (state) => state?.accessControlData?.data || [],
  );

  const hasProjectRootAccess =
    accessControlData?.projectFolderAccess == 1 ||
    accessControlData?.rootLibraryAccess == 1;
  const isvalid = type == 0 ? hasProjectRootAccess : true;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar>
        <Header />
      </AppBar>
      {/* {showdrawer &&
        (drawerVariant === "admin" ? (
          <Drawer drawerItems={drawerItems} adminDrawer />
        ) : (
          <FolderDrawerLayout navItems={""} />
        ))} */}

      {showdrawer &&
        (drawerVariant === "admin" ? (
          <Drawer drawerItems={drawerItems} adminDrawer />
        ) : isvalid ? (
          <FolderDrawerLayout navItems={""} />
        ) : null)}

      <Box component="main" sx={SC.mainBody} id={"mainBody"}>
        <DrawerHeader />

        {children}
      </Box>
    </Box>
  );
}
